import React, { useEffect, useState, useCallback } from "react";
import { Loader2 } from "lucide-react";
import { AppShell } from "@/components/app/AppShell";
import { FreeDashboard } from "@/components/dashboard/FreeDashboard";
import { ProDashboard } from "@/components/dashboard/ProDashboard";
import { PortfolioSection } from "@/components/dashboard/PortfolioSection";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadStats = useCallback(async () => {
    try {
      const r = await api.get("/dashboard/stats");
      setStats(r.data);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadStats();
  }, [loadStats]);

  // Plan resolved from the authoritative dashboard payload (falls back to user).
  const plan = stats?.plan || user?.plan || "free";

  return (
    <AppShell title="Dashboard">
      {loading || !stats ? (
        <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>
      ) : plan === "free" ? (
        <FreeDashboard stats={stats} user={user} />
      ) : (
        <ProDashboard
          stats={stats}
          user={user}
          isPm={plan === "pm"}
          portfolio={plan === "pm" ? <PortfolioSection /> : null}
        />
      )}
    </AppShell>
  );
}
